// Module
var code = "<div ref=\"changePasswordContainer\" class=\"flex-container-column\">\n    <cjs-button ref=\"changePasswordDialogButton\"></cjs-button>\n</div>";
// Exports
module.exports = code;